import { updateFeatureFlags } from '../store/reducers/appSlice';
import store from '../store/store';

export class Features {
    static add(feature: Features.Name, endpoint: Features.Endpoint[] = [Features.Endpoint.TEST]) {
        let canAdd = endpoint.includes(Features.Endpoint.ALL);
        let config = process.env.BUILD_ENV ?? ''; // comes from x.config.js dev, local, local-x, preprod, prod, stageXX, testXX
        endpoint.map((obj) => {
            switch (obj) {
                case Features.Endpoint.TEST:
                    canAdd = config.startsWith('dev') || config.startsWith('test') || config.startsWith('local');
                    break;
                case Features.Endpoint.STAGE:
                    canAdd = config.startsWith('stage');
                    break;
                case Features.Endpoint.PROD:
                    canAdd = config == 'prod' || config == 'preprod';
                    break;
            }
        });

        if (!canAdd) {
            return;
        }
        store.dispatch(updateFeatureFlags(feature as string));
    }

    static check(feature: Features.Name): boolean {
        // Features go here when they are turned on for good
        const alwaysOn: Features.Name[] = [Features.Name.EXPRESS, Features.Name.ILLUSTRATOR];
        if (alwaysOn.includes(feature)) {
            return true;
        }
        // not always on then use checks to see if its been added.
        const appState = store.getState().app;
        return appState.featureFlags.includes(feature as string);
    }

    static checkUrl() {
        const params = new URLSearchParams(document.location.search);
        const items = params.get('feature') ?? '';
        items.split(',').map((feat) => {
            if (Features.Name[feat] == undefined) {
                return;
            }
            Features.add(Features.Name[feat], [Features.Endpoint.ALL]);
        });
    }
}

export namespace Features {
    export enum Name {
        LANG_SELECT = 'FF_LanguageSelection',
        EXPRESS = 'FF_Express',
        ILLUSTRATOR = 'FF_Illustrator',
    }

    export enum Endpoint {
        TEST = 1,
        STAGE,
        PROD,
        ALL,
    }
}

export default Features;
